
/* ONDE Wave — Animations & Interactions */

document.addEventListener('DOMContentLoaded', function () {
  var body = document.body;

  /* ── Mobile Menu ───────────────────── */
  var menuBtn = document.querySelector('.site-header__menu-btn');
  var nav = document.querySelector('.site-header__nav');
  var overlay = document.querySelector('.site-header__overlay');
  var navClose = document.querySelector('.site-header__nav-close');
  var mobileBreakpoint = window.matchMedia('(max-width: 900px)');

  function closeMenu(options) {
    var opts = options || {};
    if (!menuBtn || !nav || !overlay) return;
    menuBtn.classList.remove('open');
    nav.classList.remove('open');
    overlay.classList.remove('open');
    menuBtn.setAttribute('aria-expanded', 'false');
    menuBtn.setAttribute('aria-label', 'メニューを開く');
    body.classList.remove('menu-open');
    if (opts.returnFocus) {
      menuBtn.focus();
    }
  }

  function openMenu() {
    var firstLink;
    if (!menuBtn || !nav || !overlay) return;
    menuBtn.classList.add('open');
    nav.classList.add('open');
    overlay.classList.add('open');
    menuBtn.setAttribute('aria-expanded', 'true');
    menuBtn.setAttribute('aria-label', 'メニューを閉じる');
    body.classList.add('menu-open');
    firstLink = nav.querySelector('a');
    if (firstLink) {
      window.requestAnimationFrame(function () {
        firstLink.focus();
      });
    }
  }

  if (menuBtn && nav && overlay) {
    menuBtn.setAttribute('aria-label', 'メニューを開く');

    menuBtn.addEventListener('click', function () {
      if (nav.classList.contains('open')) {
        closeMenu({ returnFocus: true });
      } else {
        openMenu();
      }
    });

    overlay.addEventListener('click', function () {
      closeMenu({ returnFocus: true });
    });

    if (navClose) {
      navClose.addEventListener('click', function () {
        closeMenu({ returnFocus: true });
      });
    }

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeMenu({ returnFocus: true });
      }
    });

    function handleMenuBreakpoint(event) {
      if (!event.matches) {
        closeMenu();
      }
    }

    if (typeof mobileBreakpoint.addEventListener === 'function') {
      mobileBreakpoint.addEventListener('change', handleMenuBreakpoint);
    } else if (typeof mobileBreakpoint.addListener === 'function') {
      mobileBreakpoint.addListener(handleMenuBreakpoint);
    }
  }

  /* ── Wave Canvas Animation ─────────── */
  function drawOndeSignatureWaveFrame(ctx, width, height, t, options) {
    var config = options || {};
    var lineCount = config.lineCount || 4;
    var stepX = config.stepX || 4;
    var baseAlpha = config.baseAlpha != null ? config.baseAlpha : 0.08;
    var alphaStep = config.alphaStep != null ? config.alphaStep : 0.04;
    var lineWidth = config.lineWidth || 1.5;
    var verticalCenter = config.verticalCenter != null ? config.verticalCenter : 0.5;
    var xScale = config.xScale != null ? config.xScale : 1;
    var xOffset = config.xOffset != null ? config.xOffset : 0;
    var amplitudeScale = config.amplitudeScale != null ? config.amplitudeScale : 1;
    var primaryBase = config.primaryBase != null ? config.primaryBase : 30;
    var primaryStep = config.primaryStep != null ? config.primaryStep : 15;
    var secondaryAmplitude = config.secondaryAmplitude != null ? config.secondaryAmplitude : 15;
    var primaryFrequency = config.primaryFrequency || 0.003;
    var secondaryFrequency = config.secondaryFrequency || 0.007;
    var phaseStep = config.phaseStep || 0.8;
    var secondarySpeed = config.secondarySpeed || 1.3;
    var strokePrefix = config.strokePrefix || 'rgba(51,51,51,';

    ctx.clearRect(0, 0, width, height);

    for (var i = 0; i < lineCount; i += 1) {
      ctx.beginPath();
      ctx.strokeStyle = strokePrefix + (baseAlpha + (i * alphaStep)) + ')';
      ctx.lineWidth = lineWidth;

      for (var x = 0; x <= width; x += stepX) {
        var waveX = (x * xScale) + xOffset;
        var y =
          (height * verticalCenter) +
          (Math.sin((waveX * primaryFrequency) + t + (i * phaseStep)) * ((primaryBase + (i * primaryStep)) * amplitudeScale)) +
          (Math.sin((waveX * secondaryFrequency) + (t * secondarySpeed) + i) * (secondaryAmplitude * amplitudeScale));

        if (x === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      }

      ctx.stroke();
    }
  }

  var heroWaveCanvas = document.getElementById('waveCanvas');
  if (heroWaveCanvas) {
    var heroWaveCtx = heroWaveCanvas.getContext('2d');
    var heroWaveT = 0;

    function resizeHeroWaveCanvas() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var width = heroWaveCanvas.offsetWidth;
      var height = heroWaveCanvas.offsetHeight;
      heroWaveCanvas.width = Math.max(Math.floor(width * dpr), 1);
      heroWaveCanvas.height = Math.max(Math.floor(height * dpr), 1);
      heroWaveCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function drawHeroWave() {
      var width = heroWaveCanvas.offsetWidth;
      var height = heroWaveCanvas.offsetHeight;
      heroWaveT += 0.008;
      drawOndeSignatureWaveFrame(heroWaveCtx, width, height, heroWaveT, {
        lineCount: 4,
        stepX: 4,
        lineWidth: 1.5,
        baseAlpha: 0.08,
        alphaStep: 0.04,
        verticalCenter: 0.5,
        xScale: 1,
        amplitudeScale: 1,
        primaryBase: 30,
        primaryStep: 15,
        secondaryAmplitude: 15,
        primaryFrequency: 0.003,
        secondaryFrequency: 0.007,
        phaseStep: 0.8,
        secondarySpeed: 1.3,
        strokePrefix: 'rgba(51,51,51,'
      });

      window.requestAnimationFrame(drawHeroWave);
    }

    resizeHeroWaveCanvas();
    window.addEventListener('resize', resizeHeroWaveCanvas);
    drawHeroWave();
  }

  function initHeroSignatureMiniWave(canvas, options) {
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    var config = options || {};
    var t = config.seed != null ? config.seed : 0;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var width = 0;
    var height = 0;
    var dpr = 1;
    var resizeRaf = 0;

    if (!ctx) return;

    function measure() {
      var rect = canvas.getBoundingClientRect();
      width = Math.max(rect.width || canvas.offsetWidth || canvas.clientWidth || parseFloat(canvas.getAttribute('width')) || 1, 1);
      height = Math.max(rect.height || canvas.offsetHeight || canvas.clientHeight || parseFloat(canvas.getAttribute('height')) || 1, 1);
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.max(Math.floor(width * dpr), 1);
      canvas.height = Math.max(Math.floor(height * dpr), 1);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function drawFrame() {
      drawOndeSignatureWaveFrame(ctx, width, height, t, {
        lineCount: 4,
        stepX: config.stepX || 0.75,
        lineWidth: config.lineWidth || 0.95,
        baseAlpha: config.baseAlpha != null ? config.baseAlpha : 0.1,
        alphaStep: config.alphaStep != null ? config.alphaStep : 0.04,
        verticalCenter: config.verticalCenter != null ? config.verticalCenter : 0.5,
        xScale: config.xScale != null ? config.xScale : 26,
        xOffset: config.xOffset != null ? config.xOffset : 64,
        amplitudeScale: config.amplitudeScale != null ? config.amplitudeScale : 0.145,
        primaryBase: 30,
        primaryStep: 15,
        secondaryAmplitude: 15,
        primaryFrequency: 0.003,
        secondaryFrequency: 0.007,
        phaseStep: 0.8,
        secondarySpeed: 1.3,
        strokePrefix: config.strokePrefix || 'rgba(51,51,51,'
      });
    }

    function render() {
      t += config.speed != null ? config.speed : 0.008;
      drawFrame();
      if (!reduceMotion) {
        window.requestAnimationFrame(render);
      }
    }

    function handleResize() {
      if (resizeRaf) {
        window.cancelAnimationFrame(resizeRaf);
      }
      resizeRaf = window.requestAnimationFrame(function () {
        measure();
        drawFrame();
      });
    }

    measure();
    render();
    window.addEventListener('resize', handleResize);
  }

  function initWaveCanvas(canvas, options) {
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var config = options || {};
    var t = config.seed != null ? config.seed : Math.random() * 10;
    var width = 0;
    var height = 0;
    var dpr = 1;
    var resizeRaf = 0;

    if (!ctx) return;

    function measure() {
      var rect = canvas.getBoundingClientRect();
      width = Math.max(rect.width || canvas.offsetWidth || canvas.clientWidth || parseFloat(canvas.getAttribute('width')) || 1, 1);
      height = Math.max(rect.height || canvas.offsetHeight || canvas.clientHeight || parseFloat(canvas.getAttribute('height')) || 1, 1);
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.max(Math.floor(width * dpr), 1);
      canvas.height = Math.max(Math.floor(height * dpr), 1);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function drawFrame() {
      var lineCount = config.lineCount || 4;
      var stepX = config.stepX || 4;
      var baseAlpha = config.baseAlpha != null ? config.baseAlpha : 0.08;
      var alphaStep = config.alphaStep != null ? config.alphaStep : 0.04;
      var baseLineWidth = config.lineWidth || 1.5;
      var primaryAmplitude = config.primaryAmplitude != null ? config.primaryAmplitude : Math.max(height * 0.08, 8);
      var secondaryAmplitude = config.secondaryAmplitude != null ? config.secondaryAmplitude : Math.max(height * 0.04, 4);
      var amplitudeStep = config.amplitudeStep != null ? config.amplitudeStep : Math.max(height * 0.03, 3);
      var verticalCenter = config.verticalCenter != null ? config.verticalCenter : 0.5;
      var lineGap = config.lineGap != null ? config.lineGap : Math.max(height * 0.08, 18);
      var slant = config.slant != null ? config.slant : 0;
      var primaryFrequency = config.primaryFrequency || 0.003;
      var secondaryFrequency = config.secondaryFrequency || 0.007;
      var phaseStep = config.phaseStep || 0.8;
      var secondarySpeed = config.secondarySpeed || 1.3;
      var strokePrefix = config.strokePrefix || 'rgba(51,51,51,';

      ctx.clearRect(0, 0, width, height);

      for (var i = 0; i < lineCount; i += 1) {
        var lineOffset = (i - ((lineCount - 1) / 2)) * lineGap;

        ctx.beginPath();
        ctx.strokeStyle = strokePrefix + (baseAlpha + (i * alphaStep)) + ')';
        ctx.lineWidth = baseLineWidth;

        for (var x = 0; x <= width; x += stepX) {
          var y =
            (height * verticalCenter) +
            lineOffset +
            (Math.sin((x * primaryFrequency) + t + (i * phaseStep)) * (primaryAmplitude + (i * amplitudeStep))) +
            (Math.sin((x * secondaryFrequency) + (t * secondarySpeed) + i) * secondaryAmplitude) +
            ((x - (width * 0.5)) * slant);

          if (x === 0) {
            ctx.moveTo(x, y);
          } else {
            ctx.lineTo(x, y);
          }
        }

        ctx.stroke();
      }
    }

    function render() {
      t += config.speed || 0.008;
      drawFrame();
      if (!reduceMotion) {
        window.requestAnimationFrame(render);
      }
    }

    function handleResize() {
      if (resizeRaf) {
        window.cancelAnimationFrame(resizeRaf);
      }
      resizeRaf = window.requestAnimationFrame(function () {
        measure();
        drawFrame();
      });
    }

    measure();
    render();
    window.addEventListener('resize', handleResize);
  }

  initHeroSignatureMiniWave(document.querySelector('.site-header__menu-wave'), {
    seed: 0.6,
    speed: 0.008,
    stepX: 0.75,
    lineWidth: 0.95,
    baseAlpha: 0.1,
    alphaStep: 0.04,
    verticalCenter: 0.5,
    xScale: 26,
    xOffset: 64,
    amplitudeScale: 0.085,
    strokePrefix: 'rgba(51,51,51,'
  });

  initWaveCanvas(document.querySelector('.site-header__nav-wave'), {
    seed: 2.4,
    lineCount: 5,
    primaryAmplitude: 14,
    secondaryAmplitude: 6,
    amplitudeStep: 5,
    lineGap: 54,
    verticalCenter: 0.5,
    speed: 0.01,
    lineWidth: 1.1,
    baseAlpha: 0.05,
    alphaStep: 0.02,
    primaryFrequency: 0.012,
    secondaryFrequency: 0.022,
    stepX: 3,
    slant: 0.045,
    phaseStep: 0.6,
    secondarySpeed: 1.35,
    strokePrefix: 'rgba(51,51,51,'
  });

  var diagnosisWaveCanvas = document.getElementById('OndeDiagnosisWaveCanvas');
  if (diagnosisWaveCanvas && window.getComputedStyle(diagnosisWaveCanvas).display !== 'none') {
    initWaveCanvas(diagnosisWaveCanvas, {
      seed: 1.4,
      lineCount: 5,
      primaryAmplitude: 18,
      secondaryAmplitude: 7,
      amplitudeStep: 5,
      lineGap: 74,
      verticalCenter: 0.54,
      speed: 0.0065,
      lineWidth: 1.1,
      baseAlpha: 0.04,
      alphaStep: 0.018,
      primaryFrequency: 0.0055,
      secondaryFrequency: 0.011,
      stepX: 3,
      slant: 0.032,
      phaseStep: 0.7,
      secondarySpeed: 1.18,
      strokePrefix: 'rgba(51,51,51,'
    });
  }

  /* ── Hero entrance ─────────────────── */
  var heroContent = document.getElementById('heroContent');
  if (heroContent) {
    window.setTimeout(function () {
      heroContent.classList.add('show');
    }, 100);
  }

  /* ── Collection filter ─────────────── */
  var tabs = document.querySelectorAll('.collection-tab[data-cat]');
  var items = document.querySelectorAll('.collection-item[data-cat]');

  if (tabs.length && items.length) {
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var category = tab.getAttribute('data-cat');

        tabs.forEach(function (button) {
          button.classList.remove('active');
        });
        tab.classList.add('active');

        items.forEach(function (item) {
          var matches = category === 'all' || item.getAttribute('data-cat') === category;
          item.hidden = !matches;
        });
      });
    });
  }

  /* ── Product quantity / purchase options ──────────────── */
  document.querySelectorAll('[data-product-purchase]').forEach(function (purchase) {
    var wrap = purchase.querySelector('.product-detail__qty');
    var input = purchase.querySelector('.product-detail__qty-input');
    var minus = purchase.querySelector('[data-qty-action="minus"]');
    var plus = purchase.querySelector('[data-qty-action="plus"]');
    var presetButtons = Array.prototype.slice.call(purchase.querySelectorAll('[data-qty-preset]'));
    var summary = purchase.querySelector('[data-purchase-summary]');
    var addLabel = purchase.querySelector('[data-add-to-bag-label]');
    var sellingPlanInput = purchase.querySelector('[data-selling-plan-input]');
    var sellingPlanRadios = Array.prototype.slice.call(purchase.querySelectorAll('[data-selling-plan-radio]'));
    var sellingPlanCards = Array.prototype.slice.call(purchase.querySelectorAll('[data-selling-plan-card]'));
    var priceWrap = purchase.closest('.product-detail__content');
    var priceValue = priceWrap ? priceWrap.querySelector('[data-product-price]') : null;
    var basePrice = Number(purchase.getAttribute('data-base-price') || 0);
    var activePrice = basePrice;
    var currency = purchase.getAttribute('data-currency') || 'JPY';
    var freeShippingThreshold = Number(purchase.getAttribute('data-free-shipping-threshold-cents') || 0);

    if (!wrap || !input || !minus || !plus) return;

    function formatMoney(cents) {
      var safeCents = Number(cents || 0);
      try {
        return new Intl.NumberFormat(currency === 'JPY' ? 'ja-JP' : undefined, {
          style: 'currency',
          currency: currency,
          maximumFractionDigits: currency === 'JPY' ? 0 : 2
        }).format(safeCents / 100);
      } catch (error) {
        return '¥' + Math.round(safeCents / 100).toLocaleString('ja-JP');
      }
    }

    function setValue(nextValue) {
      var safeValue = parseInt(nextValue, 10);
      if (isNaN(safeValue) || safeValue < 1) safeValue = 1;
      input.value = safeValue;
      updatePurchaseUi();
    }

    function syncPresetState(quantity) {
      presetButtons.forEach(function (button) {
        var isActive = parseInt(button.getAttribute('data-qty-preset'), 10) === quantity;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function getPresetSummaryLabel(quantity) {
      var matchedButton = presetButtons.find(function (button) {
        return parseInt(button.getAttribute('data-qty-preset'), 10) === quantity;
      }) || null;

      if (matchedButton) {
        return matchedButton.getAttribute('data-qty-summary-label') || (quantity + '点');
      }

      return quantity + '点';
    }

    function updateSummary() {
      var quantity = parseInt(input.value, 10) || 1;
      var total = activePrice * quantity;
      var summaryLead = getPresetSummaryLabel(quantity);
      var fragments = [summaryLead + 'で ' + formatMoney(total)];

      if (freeShippingThreshold > 0) {
        if (total >= freeShippingThreshold) {
          fragments.push('このまま送料無料です');
        } else {
          fragments.push('あと ' + formatMoney(freeShippingThreshold - total) + ' で送料無料');
        }
      }

      if (summary) {
        summary.textContent = fragments.join(' / ');
      }

      if (addLabel) {
        var baseLabel = addLabel.getAttribute('data-base-label') || 'ADD TO BAG';
        addLabel.textContent = quantity > 1 ? baseLabel + ' ×' + quantity : baseLabel;
      }
    }

    function updatePriceDisplay() {
      if (priceValue) {
        priceValue.textContent = formatMoney(activePrice);
      }
    }

    function updateSellingPlanState() {
      if (!sellingPlanRadios.length) {
        activePrice = basePrice;
        updatePriceDisplay();
        return;
      }

      var selectedRadio = sellingPlanRadios.find(function (radio) {
        return radio.checked;
      }) || null;

      var selectedValue = selectedRadio ? selectedRadio.value : '';
      var selectedPrice = selectedRadio ? Number(selectedRadio.getAttribute('data-plan-price') || basePrice) : basePrice;

      activePrice = selectedPrice || basePrice;

      if (sellingPlanInput) {
        sellingPlanInput.value = selectedValue;
      }

      sellingPlanCards.forEach(function (card) {
        var radio = card.querySelector('[data-selling-plan-radio]');
        card.classList.toggle('is-selected', !!radio && radio.checked);
      });

      updatePriceDisplay();
    }

    function updatePurchaseUi() {
      var quantity = parseInt(input.value, 10) || 1;
      syncPresetState(quantity);
      updateSellingPlanState();
      updateSummary();
    }

    minus.addEventListener('click', function () {
      setValue((parseInt(input.value, 10) || 1) - 1);
    });

    plus.addEventListener('click', function () {
      setValue((parseInt(input.value, 10) || 1) + 1);
    });

    input.addEventListener('input', function () {
      input.value = input.value.replace(/[^0-9]/g, '');
      updatePurchaseUi();
    });

    input.addEventListener('blur', function () {
      setValue(input.value);
    });

    presetButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setValue(button.getAttribute('data-qty-preset'));
      });
    });

    sellingPlanRadios.forEach(function (radio) {
      radio.addEventListener('change', updatePurchaseUi);
    });

    updatePurchaseUi();
  });


  /* ── Cart campaign participation code ───────────────── */
  (function initCartCampaignCode() {
    var form = document.querySelector('[data-cart-campaign-form]');
    if (!form) return;

    var input = form.querySelector('[data-cart-campaign-input]');
    var submit = form.querySelector('[data-cart-campaign-submit]');
    var message = form.querySelector('[data-cart-campaign-message]');
    var checkout = document.querySelector('[data-cart-checkout]');
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var checkoutPath = rootUrl + 'checkout';
    var saving = false;

    function getCode() {
      return input ? input.value.replace(/^\s+|\s+$/g, '') : '';
    }

    function normalizeCode(code) {
      return (code || '').replace(/\s+/g, '').toUpperCase();
    }

    function setMessage(text, state) {
      if (!message) return;
      message.textContent = text || '';
      if (state) {
        message.setAttribute('data-state', state);
      } else {
        message.removeAttribute('data-state');
      }
    }

    function setLoading(isLoading) {
      saving = isLoading;
      if (submit) {
        submit.disabled = isLoading;
        submit.textContent = isLoading ? '保存中' : '保存';
      }
    }

    function saveCampaignCode(code, options) {
      var opts = options || {};
      var normalizedCode = normalizeCode(code);

      if (!normalizedCode) {
        setMessage('キャンペーン参加コードを入力してください。', 'error');
        if (input) input.focus();
        return Promise.reject(new Error('campaign code is empty'));
      }

      if (input) input.value = normalizedCode;
      setLoading(true);
      setMessage('キャンペーン参加コードを保存しています…');

      return fetch(rootUrl + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            onde_campaign_code: normalizedCode
          }
        })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              throw error;
            });
          }
          return response.json();
        })
        .then(function () {
          setLoading(false);
          setMessage('キャンペーン参加コードを保存しました。割引は発生しません。対象の場合、発送時におすすめ商品を同梱します。', 'success');
          if (opts.redirect) {
            window.location.href = checkoutPath;
          }
        })
        .catch(function (error) {
          setLoading(false);
          if (opts.redirect) {
            window.location.href = checkoutPath;
            return;
          }
          var fallbackMessage = 'キャンペーン参加コードを保存できませんでした。時間をおいてもう一度お試しください。';
          if (error && error.description) {
            fallbackMessage = error.description;
          } else if (error && error.message && error.message !== 'campaign code is empty') {
            fallbackMessage = error.message;
          }
          setMessage(fallbackMessage, error && error.message === 'campaign code is empty' ? 'error' : 'error');
        });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (saving) return;
      saveCampaignCode(getCode());
    });

    if (checkout) {
      checkout.addEventListener('click', function (event) {
        var code = getCode();
        if (!code || saving) return;
        event.preventDefault();
        saveCampaignCode(code, { redirect: true });
      });
    }
  }());


  /* ── Mother's Day gift sets ─────────────────────────── */
  document.querySelectorAll('[data-mothers-day-set]').forEach(function (giftSet) {
    var button = giftSet.querySelector('[data-mothers-day-set-button]');
    var status = giftSet.querySelector('[data-mothers-day-status]');

    if (!button) return;

    button.addEventListener('click', function () {
      var ids = (button.getAttribute('data-item-ids') || '')
        .split(',')
        .map(function (value) { return value.trim(); })
        .filter(Boolean);
      var defaultLabel = button.getAttribute('data-default-label') || '母の日セットをバッグに入れる';
      var loadingLabel = button.getAttribute('data-loading-label') || 'セットをバッグに入れています…';
      var setKicker = button.getAttribute('data-set-kicker') || '母の日セット';
      var setTitle = button.getAttribute('data-set-title') || setKicker;
      var setShort = button.getAttribute('data-set-short') || setTitle;
      var setKey = button.getAttribute('data-set-key') || '';
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      if (!ids.length || button.disabled) {
        return;
      }

      button.disabled = true;
      button.classList.add('is-loading');
      if (button.firstElementChild) {
        button.firstElementChild.textContent = loadingLabel;
      } else {
        button.textContent = loadingLabel;
      }
      if (status) {
        status.textContent = '';
      }

      var items = ids.map(function (id, index) {
        return {
          id: Number(id),
          quantity: 1,
          properties: {
            '_onde_bundle_kind': 'gift-set',
            '_onde_bundle_kicker': setKicker,
            '_onde_bundle_key': setKey,
            '_onde_bundle_title': setTitle,
            '_onde_bundle_short': setShort,
            '_onde_bundle_index': String(index + 1)
          }
        };
      });

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              throw error;
            });
          }
          return response.json();
        })
        .then(function () {
          window.location.href = rootUrl + 'cart';
        })
        .catch(function (error) {
          var message = 'セットを追加できませんでした。時間をおいて、もう一度お試しください。';
          if (error && typeof error === 'object') {
            message = error.description || error.message || message;
          }
          if (status) {
            status.textContent = message;
          }
          button.disabled = false;
          button.classList.remove('is-loading');
          if (button.firstElementChild) {
            button.firstElementChild.textContent = defaultLabel;
          } else {
            button.textContent = defaultLabel;
          }
        });
    });
  });


  /* ── ONDE generic bundle sets ────────────────────── */
  document.querySelectorAll('[data-onde-bundle-set]').forEach(function (bundleSet) {
    var button = bundleSet.querySelector('[data-onde-bundle-button]');
    var status = bundleSet.querySelector('[data-onde-bundle-status]');

    if (!button) return;

    button.addEventListener('click', function () {
      var ids = (button.getAttribute('data-item-ids') || '')
        .split(',')
        .map(function (value) { return value.trim(); })
        .filter(Boolean);
      var defaultLabel = button.getAttribute('data-default-label') || 'セットをバッグに入れる';
      var loadingLabel = button.getAttribute('data-loading-label') || 'セットをバッグに入れています…';
      var bundleKicker = button.getAttribute('data-bundle-kicker') || 'ONDEセット';
      var bundleTitle = button.getAttribute('data-bundle-title') || bundleKicker;
      var bundleShort = button.getAttribute('data-bundle-short') || bundleTitle;
      var bundleKey = button.getAttribute('data-bundle-key') || '';
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      if (!ids.length || button.disabled) {
        return;
      }

      button.disabled = true;
      button.classList.add('is-loading');
      if (button.firstElementChild) {
        button.firstElementChild.textContent = loadingLabel;
      } else {
        button.textContent = loadingLabel;
      }
      if (status) {
        status.textContent = '';
      }

      var items = ids.map(function (id, index) {
        return {
          id: Number(id),
          quantity: 1,
          properties: {
            '_onde_bundle_kind': 'set',
            '_onde_bundle_kicker': bundleKicker,
            '_onde_bundle_key': bundleKey,
            '_onde_bundle_title': bundleTitle,
            '_onde_bundle_short': bundleShort,
            '_onde_bundle_index': String(index + 1)
          }
        };
      });

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              throw error;
            });
          }
          return response.json();
        })
        .then(function () {
          window.location.href = rootUrl + 'cart';
        })
        .catch(function (error) {
          var message = 'セットを追加できませんでした。時間をおいて、もう一度お試しください。';
          if (error && typeof error === 'object') {
            message = error.description || error.message || message;
          }
          if (status) {
            status.textContent = message;
          }
          button.disabled = false;
          button.classList.remove('is-loading');
          if (button.firstElementChild) {
            button.firstElementChild.textContent = defaultLabel;
          } else {
            button.textContent = defaultLabel;
          }
        });
    });
  });

  /* ── Accordions ────────────────────── */
  document.querySelectorAll('.product-detail__accordion').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var content = document.getElementById(trigger.getAttribute('aria-controls'));
      var arrow = trigger.querySelector('.product-detail__accordion-arrow');
      var expanded = trigger.getAttribute('aria-expanded') === 'true';

      if (!content) return;

      trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      content.hidden = expanded;
      if (arrow) {
        arrow.textContent = expanded ? '＋' : '−';
      }
    });
  });
});
